var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPoints = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171277878"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 439",
    cx: 6.69,
    cy: 6.5,
    r: 6.5,
    fill: "#00D0FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 12",
    d: "M6.691 2.813a6.244 6.244 0 0 0 3.69 3.689 6.244 6.244 0 0 0-3.69 3.689A6.244 6.244 0 0 0 3.002 6.5a6.244 6.244 0 0 0 3.69-3.689Z",
    fill: "#000"
  }))));
};
export default SvgPoints;